<template>
  <el-table :data="data" style="width: 100%;" :row-class-name="tableRowClassName" height="calc(100% - 140px)">
    <el-table-column label="序号" type="index" width="100">
    </el-table-column>
    <el-table-column prop="UserCode" label="客户代码">
    </el-table-column>
    <el-table-column prop="UserName" label="客户名称" :show-overflow-tooltip="true">
      <template slot-scope="scope">
        <span>{{scope.row.UserName == null ? "--" : (scope.row.UserName == "" ? "--" : scope.row.UserName)}}</span>
      </template>
    </el-table-column>
    <el-table-column prop="TransferTypeStr" label="类型" width="100">
    </el-table-column>
    <el-table-column prop="TransferMoney" label="金额" v-if="SubAccountLimit">
    </el-table-column>
    <el-table-column prop="CurrencyName" label="币种">
    </el-table-column>
    <el-table-column prop="Id" label="出入金流水号">
    </el-table-column>
    <el-table-column prop="OptDate" label="操作日期" :show-overflow-tooltip="true">
    </el-table-column>
    <el-table-column prop="OptTime" label="操作时间" width="100">
    </el-table-column>
    <el-table-column prop="OrderState" label="支付状态" :show-overflow-tooltip="true">
    </el-table-column>
    <el-table-column prop="OprName" label="操作员">
    </el-table-column>
    <el-table-column prop="MoneyTransSource" label="来源" width="100">
    </el-table-column>
    <el-table-column label="操作">
      <template slot-scope="scope">
        <el-button @click="handleClick(scope.row)" type="text" size="small">查看</el-button>
      </template>
    </el-table-column>
    <el-dialog title="查看详情" :visible.sync="dialogVisible" append-to-body width="80%">
      <div class="infobox clearfix">
          <div class="infoboxinfo">
              <span>客户代码:</span>
              <input type="text" v-model="obj.UserCode"  disabled>
          </div>
          <div class="infoboxinfo">
              <span>客户名称:</span>
              <input type="text" v-model="obj.UserName" disabled>
          </div>
            <div class="infoboxinfo">
              <span>类型:</span>
              <input type="text" v-model="obj.TransferTypeStr" disabled>
          </div>
            <div class="infoboxinfo">
              <span>金额:</span>
              <input type="text" v-model="obj.TransferMoney" disabled>
          </div>
          <div class="infoboxinfo">
              <span>币种:</span>
              <input type="text" v-model="obj.CurrencyName" disabled>
          </div>
           <div class="infoboxinfo">
              <span>出入金流水号:</span>
              <input type="text" v-model="obj.Id" disabled>
          </div>
           <div class="infoboxinfo">
              <span>操作日期:</span>
              <input type="text" v-model="obj.OptDate" disabled>
          </div>
           <div class="infoboxinfo">
              <span>操作时间:</span>
              <input type="text" v-model="obj.OptTime" disabled>
          </div>
           <div class="infoboxinfo">
              <span>支付状态:</span>
              <input type="text" v-model="obj.OrderState" disabled>
          </div>
           <div class="infoboxinfo">
              <span>操作员:</span>
              <input type="text" v-model="obj.OprName" disabled>
          </div>
           <div class="infoboxinfo">
              <span>来源:</span>
              <input type="text" v-model="obj.MoneyTransSource" disabled>
          </div>
           <div class="infoboxinfo">
              <span>汇率:</span>
              <input type="text" v-model="obj.ExchangeRate" disabled>
          </div>
           <div class="infoboxinfo">
              <span>实际支付金额:</span>
              <input type="text" v-model="obj.LocalMoneyFact" disabled>
          </div>
           <div class="infoboxinfo">
              <span>实际到账金额:</span>
              <input type="text" v-model="obj.TransferMoneyFact" disabled>
          </div>
           <div class="infoboxinfo">
              <span>人民币手续费:</span>
              <input type="text" v-model="obj.LocalMoneyFee" disabled>
          </div>
           <div class="infoboxinfo">
              <span>{{CurrencyName}}手续费:</span>
              <input type="text" v-model="obj.TransferMoneyFee" disabled>
          </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </el-table>
</template>

<script>
import EnumConfig from "../../../assets/js/EnumConfig.js";
export default {
  // 出入金明细
  name: "withdrawalDetailT",
  data() {
    return {

      SubAccountLimit: true,

      dialogVisible: false,
	  
      obj: {},
      CurrencyName: '',
    };
  },
  props: ["data"],
  created() {
    if (sessionStorage.getItem("type") == "1"){
      if (sessionStorage.getItem("SubAccountLimit") != null && sessionStorage.getItem("SubAccountLimit") != "undefined") {
        this.SubAccountLimit = JSON.parse(sessionStorage.getItem("SubAccountLimit"));
      }
    }
    this.getCurrencyName();
  },
  filters: {
    GetDirection(type) {
      return EnumConfig.GetDirection(type);
    }
  },
  methods: {
    getCurrencyName() {
      var url = "/Account/GetInsBasicCurrency";
      var post = "";
      this.$loginapi.post(url, post, response => {
        if (response.Ret == 0) {
          this.CurrencyName = response.Data.Name;
        } else {
          this.$alert(response.Msg, {});
        }
      });
    },
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex === 1) {
        return "warning-row";
      } else if (rowIndex === 3) {
        return "success-row";
      }
      return "";
    },
    handleClick(row) {
      this.dialogVisible = true;
      this.obj = row;
    }
  }
};
</script>

<style scoped>
 .infoboxinfo {
   width: 33%;
 }
</style>



// WEBPACK FOOTER //
// src/components/selects/withdrawalDetail/withdrawalDetailT.vue